import React from "react";
// import { makeStyles } from '@mui/material/styles';
import Button from "@mui/material/Button";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import ArchiveIcon from "@mui/icons-material/Archive";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import EditIcon from "@mui/icons-material/Edit";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import InfoIcon from "@mui/icons-material/Info";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { toast } from "react-toastify";
import Lottie from "lottie-react-web";

import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import SelectClosingStatus from "./SelectClosingStatus";
import Preloading from "../Preload/Preloading";
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";
import { useDispatch } from "react-redux";
import { useState } from "react";

const cookies = new Cookies();
var spin;
// const useStyles = makeStyles((theme) => ({
//   root: {
//     height: 100,
//     transform: 'translateZ(0px)',
//     flexGrow: 1,

//   },
//   speedDial: {
//     position: 'absolute',
//     bottom: theme.spacing(2),
//     left: theme.spacing(2),
//   },
// }));

export default function OpenIconSpeedDial(props) {
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);
  const dispatch = useDispatch();
  const [closingStatuses, setClosingStatuses] = React.useState([]);
  const [addForm, setAddForm] = useState(false);

  async function myFunction(data) {
    if (!props?.allowChangeStatus && props && !props?.erp_cus_id) {
      toast.warn(
        "Please, you must replace this customer with a new customer to continue!"
      );
      return;
    }
    const headers = {
      jwt: cookies.get("token"),
    };
    spin = true;

    console.log(data);

    if (data == 3) {
      // if the status is close task then show closing status
      console.log("in");
      setOpenDialog(true);
      setAddForm(true);
    } else {
      console.log("out");
      dispatch(setGlobalLoading(true));

      axios({
        url: Host + `tasks/change_status/${props.id}`,
        method: "PUT",
        headers: headers,
        data: { status_id: data },
      })
        .then((res) => {
          if (res.data.status === true) {
            dispatch(setGlobalLoading(false));

            toast.success("task updated successfully");
            const { onRefTask } = props.onRefTask;
            if (
              props?.SubTaskId &&
              (props?.subTaskData?.status == "new" ||
                props?.subTaskData?.status == "in progress") &&
              props?.taskTypeId != 15 &&
              props?.taskTypeId != 9 &&
              data > 2
            ) {
              props?.setShowPromot(true);
            }
            if (props?.SubTaskId) props?.getSubTaskData(props?.SubTaskId);

            if (props?.is_installation) {
              props?.getData();
            } else onRefTask();
            spin = false;
          } else if (res.data.status === false) {
            dispatch(setGlobalLoading(false));
            toast.error(res.data.data.message.text ? res.data.data.message.text : res.data.data.message);
            spin = false;
          }
        })
        .catch((err) => {
          dispatch(setGlobalLoading(false));

          toast.error("Network Error");
          spin = false;
        });
    }
  }
  // const handleVisibility = () => {
  //   setHidden((prevHidden) => !prevHidden);
  // };
  const actions = [
    {
      icon: (
        <AutorenewIcon
          onClick={() => {
            myFunction(2);
          }}
        />
      ),
      name: "In Progress",
    },
    {
      icon: (
        <DoneAllIcon
          onClick={() => {
            myFunction(3);
          }}
        />
      ),
      name: "Close",
    },
    {
      icon: (
        <ThumbUpIcon
          onClick={() => {
            myFunction(5);
          }}
        />
      ),
      name: "Approve",
    },
    {
      icon: (
        <ThumbDownIcon
          onClick={() => {
            myFunction(4);
          }}
        />
      ),
      name: "Reject",
    },
    {
      icon: (
        <ArchiveIcon
          onClick={() => {
            myFunction(6);
          }}
        />
      ),
      name: "Archive",
    },
    {
      icon: (
        <FiberNewIcon
          onClick={() => {
            myFunction(1);
          }}
        />
      ),
      name: "New",
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setOpenDialogFromChild = (open) => {
    spin = false;
    setOpenDialog(open);
  };

  React.useEffect(() => {
    loadClosingStatuses();
    return () => {};
  }, []);

  ////closing statuses related functions and variables
  const [isLoadPanelVisible, setisLoadPanelVisible] = React.useState(false);

  const [selectedClosingStatus, setSelectedClosingStatus] = React.useState({
    id: 1,
    name: "successful",
    color: "green",
  });
  const [openDialog, setOpenDialog] = React.useState(false);

  const loadClosingStatuses = async () => {
    const headers = {
      jwt: cookies.get("token"),
    };
    console.log("asdasdasdas", props?.status);
    try {
      const closingStatusesResult = await axios({
        url: Host + `closing_statuses/`,
        method: "GET",
        headers: headers,
      });
      if (closingStatusesResult.data.status === true) {
        if(props?.taskTypeId === 17) {
          setClosingStatuses(closingStatusesResult.data.data?.filter((s) => s?.id !== 2 && s?.id !== 3));
        } else {
          setClosingStatuses(closingStatusesResult.data.data);
        }
      } else if (closingStatusesResult.data.status === false) {
        toast.error(closingStatusesResult.data.data.message.text);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const onSave = () => {
    if (!selectedClosingStatus) {
      toast.warn("You must select a closing status");
      return;
    }
    const headers = {
      jwt: cookies.get("token"),
    };

    setOpenDialog(false);
    dispatch(setGlobalLoading(true));
    axios({
      url: Host + `tasks/change_status_to_close/${props.id}`,
      method: "PUT",
      headers: headers,
      data: { status_id: 3, close_status_id: selectedClosingStatus },
    })
      .then((res) => {
        if (res.data.status === true) {
          setAddForm(false);
          toast.success("task updated successfully");
          const { onRefTask } = props.onRefTask;

          if (
            props?.SubTaskId &&
            (props?.subTaskData?.status == "new" ||
              props?.subTaskData?.status == "in progress") &&
            props?.taskTypeId != 15 &&
            props?.taskTypeId != 9
          ) {
            props?.setShowPromot(true);
          }
          if (props?.SubTaskId) props?.getSubTaskData(props?.SubTaskId);
          if (props?.is_installation) {
            props?.getData();
          } else onRefTask();
          spin = false;
          dispatch(setGlobalLoading(false));
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text ? res.data.data.message.text : res.data.data.message);
          spin = false;
          dispatch(setGlobalLoading(false));
        }
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
        toast.error("Network Error");
        spin = false;
      });
  };

  return (
    <div
    //  className={classes.root}
    >
      <SelectClosingStatus
        setAddForm={setAddForm}
        addForm={addForm}
        closingStatuses={closingStatuses}
        setisLoadPanelVisible={setisLoadPanelVisible}
        isLoadPanelVisible={isLoadPanelVisible}
        onSave={onSave}
        selectedClosingStatus={selectedClosingStatus}
        setSelectedClosingStatus={setSelectedClosingStatus}
        showForm={openDialog}
        setOpenDialog={setOpenDialogFromChild}
      />
      {/* <Button onClick={handleVisibility}>Toggle Speed Dial</Button> */}
      <SpeedDial
        ariaLabel="SpeedDial openIcon example"
        // className={classes.speedDial}
        hidden={hidden}
        icon={
          <SpeedDialIcon
            sx={{ color: props?.iconColor ? props?.iconColor : "#fff" }}
            openIcon={
              <EditIcon
                sx={{ color: props?.iconColor ? props?.iconColor : "#fff" }}
              />
            }
          />
        }
        onClose={handleClose}
        onOpen={handleOpen}
        open={props?.is_installation ? true : open}
        direction={"right"}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={handleClose}
          />
        ))}
      </SpeedDial>
    </div>
  );
}
